import mixinMutations from '../core/mutations';
import mixinGetters from '../core/getters';
import mixinActions from '../core/actions';
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        bets: [],
        repositoryName: 'bets',
        stats: {
            abnormal_bet_count: 0,
            balance: 0,
            rejected_bet_count: 0,
            settled_bet_count: 0,
            settled_stake_sum: 0,
            total_bet_count: 0,
            total_stake_sum: 0,
            total_valid_stake_sum: 0,
            unsettled_bet_count: 0,
            unsettled_stake_sum: 0,
            yield: 0,
        },
        filters: {
            date: [],
            bookmakerId: [],
            botId: [],
            tradingTypeId: null,
            search: null,
            statusId: null,
            marketTypeId: null,
        },
        isShowExtraFilters: false,
    },
    mutations: {
        ...mixinMutations(),
    },
    getters: {
        ...mixinGetters(),
    },
    actions: {
        ...mixinActions('bet'),
        exportFile(context, params) {
            let columns =
                '{"created_at":"Date","trading_type_id":"Type","bot_order_name":"Bot/Order","site_id":"Bookmaker","period_type_id":"Market Period","game_type_id":"Market Mode","status_id":"Status","iso3":"","custom_team_home_name":"Home","custom_team_away_name":"Away","score_ft":"FT Score","score_ht":"HT Score","bet_type":"Bet Type","type":"Bet","odds":"Odds", "score":"Score","minute":"Minute", "margin_perc":"Market Margin","stake":"Stake","mis_stake":"M Stake","balance":"Balance","result":""}';
            return axios
                .get('/api/bet/list', {
                    responseType: 'arraybuffer',
                    params: {
                        filter: params.filters,
                        sort: JSON.stringify([
                            {
                                property: params.options.sortBy[0],
                                direction: params.options.sortDesc[0] ? 'ASC' : 'DESC',
                            },
                        ]),
                        columns,
                        toXls: 1,
                    },
                })
                .then((response) => {
                    return Promise.resolve(response);
                });
        },
    },
};
